import * as React from 'react'
import { SVGProps } from 'react'
const SvgBraintreeExpirationDate = (props: SVGProps<SVGSVGElement>) => (
  <svg
    className="-s-braintree-cvv"
    width={24}
    height={16}
    viewBox="0 0 24 16"
    fill="none"
    {...props}
  >
    <path
      d="M0 3a3 3 0 0 1 3-3h18a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3Z"
      fill="#E5E5EA"
    />
    <rect x={3} y={8} width={18} height={2} rx={0.5} fill="#C7C7CC" />
    <rect x={3} y={3} width={3} height={3} rx={0.5} fill="#fff" />
    <rect x={11.5} y={10.5} width={6} height={4} rx={2} stroke="#FF3B30" />
  </svg>
)
export default SvgBraintreeExpirationDate
